import {rule} from '@/util/validateRules'

export const addInsured = {
	addRowBtn: true,
	addBtnText: '添加被保企业',
	addBtn: false,
	editBtn: false,
	delBtn: false,
	index: true,
	refreshBtn: false,
	columnBtn: false,
	indexLabel: '序号',
	border: true,
	stripe: true,
	align: 'center',
	menuWidth: 130,
	gridBtn: false,
	column: [
		{
			label: '企业名称',
			prop: 'unitName',
			cell: true,
			disabled: false,
			rules: [
				{
					required: true,
					message: '请输入 企业名称',
					trigger: 'blur',
				},
			],
		},
		{
			label: '统一信用代码',
			prop: 'unitCode',
			cell: true,
			disabled: false,
			rules: [
				{
					required: true,
					message: '请输入 企业统一信用代码',
					trigger: 'blur',
				},
				{
					validator: rule.validatorCreditCode,
				},
			],
		},
		{
			label: '与原被保企业关系',
			prop: 'relation',
			type: 'select',
			slot: true,
			cell: true,
			disabled: false,
			props: {
				label: 'name',
				value: 'value',
			},
			rules: [
				{
					required: true,
					message: '请选择 被保企业关系',
					trigger: 'blur',
				},
			],
		},
		{
			label: '省市区',
			prop: 'areaCode',
			type: 'cascader',
			cell: true,
			disabled: false,
			props: {
				label: 'areaName',
				value: 'areaCode',
			},
			rules: [
				{
					required: true,
					message: '请选择 省市区',
					trigger: 'blur',
				},
			],
		},
		{
			label: '营业执照',
			prop: 'licensePath',
			type: 'upload',
			cell: true,
			disabled: false,
			display: false,
			listType: 'picture-img',
			action: '/dist/distInsure/uploadFile',
			propsHttp: {
				res: 'data',
			},
			dragFile: true,
			accept: 'image/png, image/jpeg',
			// tip: '请上传大小不超过4Mb的jpg/png文件',
			rules: [
				{
					required: true,
					message: '请上传营业执照',
					trigger: 'blur',
				},
			],
		},
		{
			label: '实际控制人姓名',
			prop: 'controllerName',
			cell: true,
			disabled: false,
			display: false,
			rules: [
				{
					required: true,
					message: '请输入 实际控制人姓名',
					trigger: 'blur',
				},
			],
		},
		{
			label: '身份证号',
			prop: 'controllerIdNo',
			cell: true,
			disabled: false,
			display: false,
			rules: [
				{
					required: true,
					message: '请输入 身份证号',
					trigger: 'blur',
				},
				// {
				// 	required: true,
				// 	validator: rule.validatorIdNo,
				// 	trigger: 'blur',
				// },
			],
		},
	],
}

export const addInsuredImg = {
	emptyBtn: false,
	submitBtn: false,
	column: [],
}

export const editInsured = {
	addRowBtn: false,
	menu: false,
	addBtn: false,
	editBtn: false,
	delBtn: false,
	refreshBtn: false,
	columnBtn: false,
	border: true,
	stripe: true,
	align: 'center',
	header: false,
	column: [
		{
			label: '企业名称',
			prop: 'unitName',
			disabled: false,
			cell: true,
			rules: [
				{
					required: true,
					message: '请输入 企业名称',
					trigger: 'blur',
				},
			],
		},
		{
			label: '统一信用代码',
			prop: 'unitCode',
			disabled: false,
			cell: true,
			rules: [
				{
					required: true,
					message: '请输入 企业统一信用代码',
					trigger: 'blur',
				},
				{
					validator: rule.validatorCreditCode,
				},
			],
		},
		{
			label: '省市区',
			prop: 'areaCode',
			type: 'cascader',
			disabled: false,
			cell: true,
			props: {
				label: 'areaName',
				value: 'areaCode',
			},
			rules: [
				{
					required: true,
					message: '请选择 省市区',
					trigger: 'blur',
				},
			],
		},
	],
}

//选择批量被保险人
export const editMoreInsured = {
	card: true,
	stripe: true,
	border: true,
	align: 'center',
	menuAlign: 'center',
	menu: false,
	addBtn: false,
	selection: true,
	selectClearBtn: false,
	searchMenuSpan: 6,
	selectionWidth: 100,
	searchLabelWidth: 120,
	header: false,
	reserveSelection: true,
	rowKey: 'orderId',
	column: [
		{
			label: '保单号',
			prop: 'policyNo',
		},
		{
			label: '被保企业/个人',
			prop: 'insured',
			search: true,
		},
		{
			label: '保险产品',
			prop: 'sysProductName',
		},
		{
			label: '承保公司',
			prop: 'companyName',
		},
		{
			label: '状态',
			prop: 'status',
			dicData: [
				{
					label: '退保',
					value: 0,
				},
				{
					label: '待支付',
					value: 1,
				},
				{
					label: '处理中',
					value: 2,
				},
				{
					label: '保障中',
					value: 3,
				},
				{
					label: '待起保',
					value: 3.5,
				},
				{
					label: '已取消',
					value: 4,
				},
				{
					label: '已到期',
					value: 5,
				},
			],
		},
		{
			label: '保险起期',
			prop: 'startDate',
			type: 'datetime',
			format: 'yyyy-MM-dd HH:mm:ss',
			valueFormat: 'yyyy-MM-dd HH:mm:ss',
		},
		{
			label: '保险止期',
			prop: 'endDate',
			type: 'datetime',
			format: 'yyyy-MM-dd',
			valueFormat: 'yyyy-MM-dd',
			formatter: (val) => {
				return val.endDate + ' 23:59:59'
			},
		},
	],
}

//选择批量被保险人
export const editMoreSelectedInsured = {
	stripe: true,
	border: true,
	align: 'center',
	menuAlign: 'center',
	menu: false,
	addBtn: false,
	header: false,
	column: [
		{
			label: '保单号',
			prop: 'policyNo',
		},
		{
			label: '原被保企业',
			prop: 'unitName',
		},
		{
			label: '统一信用代码',
			prop: 'unitCode',
		},
		{
			label: '保险起期',
			prop: 'effectiveDate',
		},
		{
			label: '保险止期',
			prop: 'expiryDate',
		},
		{
			label: '状态',
			prop: 'statusText',
			hide: true,
		},
	],
}
